// extracted by mini-css-extract-plugin
export var deleteModal = "_rr-0";